import React, { useMemo } from "react";
import { useMeeting } from "@videosdk.live/react-sdk";
import { useDispatch, useSelector } from "react-redux";
import {
  ToggleCamera,
  ToggleMic
} from "../../common/game/GameControl";
import { handleCamera, handleMic } from "../../slice/gameStateSlice";

const ToggleCameraButton = () => {
  const meetingAPI = useMeeting();
  const dispatch = useDispatch();
  const gameState = useSelector((state) => state.gameState);
  const isMeetingJoined = useSelector((state) => state.auth.isMeetingJoined);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );
  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  const handleWebCamera = (status) => {
    if (!meetingAPI) return;
    if (status && !currentPlayer.IsRealTimeChat) {
      meetingAPI.enableWebcam?.();
    } else {
      meetingAPI.disableWebcam?.();
    }

    ToggleCamera(user.Id, gameState.GameCode, currentIndex, status, () => {
      dispatch(handleCamera({ index: currentIndex, value: status }));
    });
  };

  const handleWebMic = (status) => {
    if (!meetingAPI) return;
    if (status && !currentPlayer.IsRealTimeChatForMic) {
      meetingAPI.unmuteMic?.();
    } else {
      meetingAPI.muteMic?.();
    }

    ToggleMic(user.Id, gameState.GameCode, currentIndex, status, () => {
      dispatch(handleMic({ index: currentIndex, value: status }));
    });
  };

  if (!isMeetingJoined || !meetingAPI) return <></>;

  if (!currentPlayer.IsRealTimeChat)
    return (
      <>
        <button
          className="btn ml-1 mt-1 stencil"
          style={{ color: "white" }}
          onClick={() => handleWebCamera(true)}
        >
          <i className="bi bi-camera-video-off h4"></i>
        </button>

        {currentPlayer.IsRealTimeChatForMic ? (
          <button
            className="btn ml-1 mt-1 stencil"
            style={{ color: "white" }}
            onClick={() => handleWebMic(false)}
          >
            <i className="bi bi-mic-fill h4"></i>
          </button>
        ) : (
          <button
            className="btn ml-1 mt-1 stencil"
            style={{ color: "white" }}
            onClick={() => handleWebMic(true)}
          >
            <i className="bi bi-mic-mute-fill h4"></i>
          </button>
        )}
      </>
    );
  else if (currentPlayer.IsRealTimeChat)
    return (
      <>
        <button
          className="btn ml-1 mt-1 stencil"
          style={{ color: "white" }}
          onClick={() => handleWebCamera(false)}
        >
          <i className="bi bi-camera-video h4"></i>
        </button>
        {currentPlayer.IsRealTimeChatForMic ? (
          <button
            className="btn ml-1 mt-1 stencil"
            style={{ color: "white" }}
            onClick={() => handleWebMic(false)}
          >
            <i className="bi bi-mic-fill h4"></i>
          </button>
        ) : (
          <button
            className="btn ml-1 mt-1 stencil"
            style={{ color: "white" }}
            onClick={() => handleWebMic(true)}
          >
            <i className="bi bi-mic-mute-fill h4"></i>
          </button>
        )}
      </>
    );
};

export default ToggleCameraButton;
